module.exports = new Promise(async (resolve, reject) => {
  /* ─────────── 1. look up the URL ─────────── */
  const urlGetter = window.__mf_getUrl
  const remoteUrl = urlGetter && urlGetter('admin_panel')

  if (!remoteUrl) {
    reject(new Error('No URL configured for remote "admin_panel"'))
    return
  }
  if (!/^(https?):\/\//.test(remoteUrl)) {
    reject(new Error('Invalid URL for remote "admin_panel": ' + remoteUrl))
    return
  }

  /* ─────────── 2. quick HEAD pre-flight (3s) ─────────── */
  const fetchWithTimeout = (url, timeoutMs = 3000) =>
    new Promise((res, rej) => {
      const t = setTimeout(() => rej(new Error('Timeout while checking ' + url)), timeoutMs)
      fetch(url, { method: 'HEAD' })
        .then(r => { clearTimeout(t); res(r) })
        .catch(e => { clearTimeout(t); rej(e) })
    })

  try {
    const head = await fetchWithTimeout(remoteUrl)
    if (!head.ok) {
      reject(new Error('Remote "admin_panel" responded with HTTP ' + head.status))
      return
    }
  } catch (err) {
    reject(new Error('Failed to fetch remote "admin_panel": ' + err.message))
    return
  }

  /* ─────────── 3· already loaded? ─────────── */
  if (window['admin_panel']) {
    resolve(window['admin_panel'])
    return
  }

  /* ─────────── 4· inject <script> and init ─────────── */
  const script = document.createElement('script')
  script.src = remoteUrl
  script.type = 'text/javascript'
  script.async = true

  script.onload  = () => resolve(window['admin_panel'])

  script.onerror = () => {
    script.remove()
    reject(new Error('Failed to load remote "admin_panel" from ' + remoteUrl))
  }

  document.head.appendChild(script)
});